<app-back-header-atom
  [icon]="'arrow-left'"
  [text]="'basket.my-order' | translate"
  [textColor]="textColor"
  [backgroundColor]="backgroundColor"
  (navigationClick)="back()"
></app-back-header-atom>
<div
  class="mx-auto py-4 lg:pt-12 lg:pb-10"
  [style.color]="textColor | contentBuilderColor"
  [ngClass]="{
    'hidden lg:block ': (hideCartParameters$ | async),
  }"
>
  @if (!(hideCartParameters$ | async)) {
    <div class="flex justify-center px-4 lg:px-0">
      <div
        class="bg-neutral-100 w-fit w-full sm:w-auto mx-auto max-w-md px-2 py-2 lg:max-w-xl rounded-md"
      >
        <app-cart-parameters-overview
          [iconBackgroundColor]="iconBackgroundColor"
          [iconColor]="iconColor"
          [textColor]="labelColor"
        ></app-cart-parameters-overview>
      </div>
    </div>
  }
</div>
